// src/components/AppErrorBoundary.js
// Boundary racine : sans elle, une erreur de rendu hors Roulette démonte toute l'app (écran blanc)
// sans laisser de trace. On la journalise (react_render_crash) et on propose de recharger.
import React from 'react';
import { scrub, topFrames, emitMonitoringEvent } from '../utils/globalErrorMonitor';
import { deviceInfo } from '../utils/staveRenderMonitor';
import { reloadOnChunkError } from '../utils/staleVersion';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    try {
      const page = window.location.pathname;
      emitMonitoringEvent('error', 'react_render_crash', {
        exerciseId: `${page}|${scrub(error?.message, 60)}`,
        errorMessage: scrub(error?.message),
        stack: topFrames(error?.stack),
        componentStack: topFrames(info?.componentStack),
        page,
        ...deviceInfo(),
      });
    } catch { /* ne jamais aggraver un crash */ }
    // Chunk introuvable = vieille version en cache : un rechargement la remplace, sans écran d'erreur
    if (/Loading chunk|ChunkLoadError|dynamically imported module/i.test(error?.message || '')) reloadOnChunkError();
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, background: '#f8fafc', color: '#0f172a', textAlign: 'center' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Oups, un problème est survenu</h1>
        <p style={{ margin: 0, maxWidth: 420 }}>L'erreur a été signalée automatiquement. Recharge la page pour reprendre.</p>
        <button type="button" onClick={() => window.location.reload()}
          style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: '#0f172a', color: '#ffffff', fontWeight: 600, cursor: 'pointer' }}>
          Recharger
        </button>
      </div>
    );
  }
}

export default AppErrorBoundary;
